module.exports = __webpack_public_path__ + "img/partner 22.85220f13.png";